import logger from '@/utils/logger'

/**
 * GTM dataLayer 基础操作
 */

/**
 * 初始化 dataLayer
 */
export function ensureDataLayer() {
  window.dataLayer = window.dataLayer || []
}

/**
 * 推送事件到 GTM dataLayer
 * @param {string} eventName - 事件名称
 * @param {object} eventData - 事件数据
 */
export function pushEvent(eventName, eventData = {}) {
  ensureDataLayer()
  window.dataLayer.push({
    event: eventName,
    ...eventData
  })
  logger.debug(`[GTM] Event pushed: ${eventName}`, eventData)
}

/**
 * 设置用户属性（用于用户分群）
 * @param {object} userProperties - 用户属性
 */
export function setUserProperties(userProperties) {
  ensureDataLayer()
  window.dataLayer.push({
    event: 'set_user_properties',
    user_properties: userProperties
  })
}
